<template>
  <div class="flex items-center -my-100">
    <span class="text-accent-accent-success">
      {{ $t('common.words.freeticket') }}
    </span>

    <LcInfoButton
      :key="`infobutton_${locale}`"
      class="ml-100"
      :headline="title"
      :open-button-aria-label="title"
      :text="
        $t('myorders.freeticket.info.text', {
          name,
        })
      "
    />
  </div>
</template>

<script lang="ts" setup>
const { locale, t } = useI18n()

defineProps<{ name: string }>()

const title = t('myorders.freeticket.info.title')
</script>
